import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import AMultiSelect from "../../common/form-fields-mui/AMultiSelect";
import {
  academicGroup,
  initialFilters,
  phaseDropdown,
  phaseStatus,
} from "./constants";
import AAutoComplete from "../../common/form-fields-mui/AAutoComplete";
import { InputLabel } from "@mui/material";
import CustomDatePicker from "../../common/commonComponents/CustomDatePicker";
import moment from "moment";
import AButton from "../../common/form-fields-mui/AButton";
import { InputLabelStyle } from "../../common/form-fields-mui/ASelect";
import { isFilterApplied } from "../../edpOps/constant/batch-search";

const FilterPhaseRows = ({
  closeForm,
  crctDropdown,
  applyFilter,
  filterForm,
  filterFormHandler,
  filterCount,
  setFilterCount,
}) => {
  const handleApplyFilter = () => {
    closeForm();
    applyFilter(filterForm);

    const filterCount = isFilterApplied({
      ...filterForm,
    });

    setFilterCount(filterCount);
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Phase"
            currentValue={filterForm.phaseName}
            items={phaseDropdown}
            handleChange={(value) => {
              filterFormHandler(value, "phaseName");
            }}
            isMulti={false}
          />

          <AMultiSelect
            label="Academic Group"
            items={academicGroup}
            currentValue={filterForm.academicGroup}
            inputKey="academicGroup"
            handleChange={filterFormHandler}
          />

          <AMultiSelect
            label="CRCT"
            items={crctDropdown}
            currentValue={filterForm.crct}
            inputKey="crct"
            handleChange={filterFormHandler}
          />

          <div>
            <InputLabel style={InputLabelStyle}>Date range</InputLabel>
            <Row>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="From"
                  // minDate={moment()}
                  value={
                    filterForm?.fromDate ? moment(filterForm?.fromDate) : null
                  }
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "fromDate");
                  }}
                />
              </Col>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="To"
                  value={filterForm?.toDate ? moment(filterForm?.toDate) : null}
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "toDate");
                  }}
                  minDate={moment(filterForm?.fromDate)}
                  disabled={!filterForm?.fromDate}
                />
              </Col>
            </Row>
          </div>

          <AAutoComplete
            label="Status"
            currentValue={filterForm.status}
            items={phaseStatus}
            handleChange={(value) => {
              filterFormHandler(value, "status");
            }}
            isMulti={false}
          />

          <div className="mt-3 d-flex flex-row-reverse justify-content-between">
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={handleApplyFilter}
              disabled={
                !filterForm.phaseName &&
                !filterForm.academicGroup.length &&
                !filterForm.crct.length &&
                !filterForm.status &&
                (!filterForm.fromDate || !filterForm.toDate)
              }
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={() => {
                  closeForm();
                  // setFilte;
                  applyFilter(initialFilters);
                  setFilterCount(0);
                }}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default FilterPhaseRows;
